import { Badge, BadgeProps, Text } from '@cmpsr/components';

type BelowAverageBadgeProps = BadgeProps & {
  isRisk?: boolean;
};

export default function BelowAverageBadge({ isRisk, ...props }: BelowAverageBadgeProps) {
  const text = isRisk ? 'Below Average Risk' : 'Below Average';

  return (
    <Badge w="max-content" backgroundColor="alert-success-default" py="2px" {...props}>
      <Text color="text-success" variant="text-body-floating-label-bold" textTransform="capitalize">
        {text}
      </Text>
    </Badge>
  );
}
